import { render } from "./SchoolStudents.vue?vue&type=template&id=51ce3bf9&scoped=true"
import script from "./SchoolStudents.vue?vue&type=script&lang=js"
export * from "./SchoolStudents.vue?vue&type=script&lang=js"

import "./SchoolStudents.vue?vue&type=style&index=0&id=51ce3bf9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ce3bf9"]])

export default __exports__